<div [@slideUpAndDown]="state()" class="CeSnackbar flex-row flex-middle flex-center flex-nowrap u-spacing-sm-pv u-spacing-md-ph {{ stateClass() }}">
    <div class="CeSnackbar-content flex flex-middle flex-center">
        <div class="CeSnackbar-message flex flex-middle flex-center">
            @if (snackbarState() === 'loading') {
            <ce-spinning-loader />
            } @else if (data.icon) {
            <ce-icon [svgIcon]="data.icon" aria-hidden="true" />
            }
            <span class="u-text-align-left u-text-body-sm">
                {{ data.message }}
            </span>
        </div>
        @if(data.actions && data.actions.length > 0){
        <div class="CeSnackbar-actions u-spacing-none-pa flex flex-middle flex-center">
            @for(action of data.actions; track action.label){
            <button ce-link-button ce-link-button-small ce-link-button-type-inverted (click)="handleActionClick(action)" class="CeSnackbar-action">
                {{ action.label }}
            </button>
            }
        </div>
        }
    </div>
    @if (snackbarState() !== 'loading' && (snackbarState() === 'error' || data.showCloseButton)) {
    <div class="CeSnackbar-close flex-col u-spacing-sm-ml">
        <button type="button" ce-button ce-button-ghost class="CeSnackbar-close" (click)="onCloseClick()" [attr.aria-label]="'Close snackbar'">
            <ce-icon [svgIcon]="'close'" size="ce-icon-sm" [attr.aria-hidden]="true" />
        </button>
    </div>
    }
</div>
